"use strict";
// AUTO-GENERATED CODE. DO NOT MODIFY!
exports.__esModule = true;
var apsDisplayEnums;
(function (apsDisplayEnums) {
    var CountDisplayInterval;
    (function (CountDisplayInterval) {
        CountDisplayInterval[CountDisplayInterval["Last24Hours"] = 0] = "Last 24 Hours";
        CountDisplayInterval[CountDisplayInterval["CurrentHour"] = 1] = "Current Hour";
        CountDisplayInterval[CountDisplayInterval["PreviousHour"] = 2] = "Previous Hour";
        CountDisplayInterval[CountDisplayInterval["CurrentShift"] = 3] = "Current Shift";
        CountDisplayInterval[CountDisplayInterval["LastShift"] = 4] = "Shift -1";
        CountDisplayInterval[CountDisplayInterval["ShiftBeforeLast"] = 5] = "Shift -2";
        CountDisplayInterval[CountDisplayInterval["RollingHour"] = 6] = "Rolling Hour";
        CountDisplayInterval[CountDisplayInterval["LastTwentyMinutes"] = 7] = "Rolling 20 Min";
    })(CountDisplayInterval = apsDisplayEnums.CountDisplayInterval || (apsDisplayEnums.CountDisplayInterval = {}));
})(apsDisplayEnums = exports.apsDisplayEnums || (exports.apsDisplayEnums = {}));


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dto/enums.js
// module id = 27
// module chunks = 0